import * as React from "react";
import styled, { withTheme, ThemeProps } from "styled-components";
import { ITheme } from "../../../themes/types";
import { connect } from "react-redux";
import { FilterAlarm, filterAlarm, FilterDeviceType, filterDeviceType, FilterUserTags, filterUserTags } from "@Safemate/DeviceList/Store/actions";
import EChartsReact from "echarts-for-react";
import { ChartValues } from ".";
import { Header } from "./card";

const Container = styled.div`
  margin: 0 auto;
  background: ${props => props.theme.colors.backgroundPrimary};
  border: ${props => props.theme.colors.border};
  border-radius: ${props => props.theme.colors.borderRadius}; 
  padding-bottom: 1em;
  color: ${props => props.theme.colors.textPrimary};
  min-height: 400px;
  margin-bottom: 10px;
  .echarts-for-react{
    height: 360px !important;
  }

`;

interface DonutProps extends ThemeProps<ITheme> {
  values: ChartValues;
  title: string;
  customScale: number;
  filterAlarm: FilterAlarm;
  filterDeviceType: FilterDeviceType;
  filterUserTags: FilterUserTags;
}

const mapDispatchToProps = {
  filterAlarm,
  filterDeviceType,
  filterUserTags
}

const Donut = connect(null, mapDispatchToProps)(withTheme(({ theme, filterAlarm, filterDeviceType, filterUserTags, values, title }: DonutProps) => {

  console.log(values);

  const total = values.values.reduce((sum, item) => sum + item.value, 0);

  const withPercentages = values.values.map(item => ({
    ...item,
    percentage: Math.round((item.value / total) * 100) + '%'
  })).sort((a, b) => b.value - a.value);


  const options = {
    color: [
      '#80CFFF', // Light Blue
      '#90DFA4', // Light Green
      '#FCD770', // Yellow
      '#FF998F', // Coral
      '#FFD77A', // Light Orange
      '#D7B4F3', // Lavender
      '#FFB46A', // Peach
      '#B0E3FF', // Sky Blue
      '#B6F1C5', // Mint Green
      '#FFE29E', // Pale Yellow
      '#F8C1B6', // Light Coral
      '#FFDECC', // Creamy Orange
      '#DEC7F4', // Soft Purple
      '#99D8EB', // Aqua
      '#C3F1A1', // Lime Green
      '#FFE1A0', // Soft Mustard
      '#FFA8C9', // Pink
      '#E3BAFF', // Orchid
      '#ADD7FF', // Pale Blue
      '#A4F4D0'  // Aqua Mint
    ],
    textStyle: {
      fontSize: "16px",
      color: theme.colors.textPrimary
    },
    tooltip: {
      trigger: 'item'
    },
    legend: {
      type: 'scroll',
      orient: 'vertical',
      left: '10px',
      top: 'middle',
      formatter: (name: string) => {
        const item = values.values.find(d => d.name === name);
        const v = item ? item.value : 0;
        return `{num|${v}}{label|${name}}`;
      },
      textStyle: {
        color: "#cfd3dc",
        align: "left",
        lineHeight: 22,
        rich: {
          num: {
            width: 32,
            lineHeight: 22,
          },
          label: {
            width: 200,   
            lineHeight: 22,
            padding: [0, 0, 0, 4]
          },
        },
      }
    },
    series: [
      {
        itemStyle : {
          borderColor: '#fff',
          borderType: "solid",
          borderWidth: 2,
          normal : {
               label : {
                  show: true, 
                  position: 'inner',
                  formatter : function (params: any){
                    return  params.data.percentage;
                  },
              },
              labelLine : {
                  show : false
              }
          }
        },
        type: 'pie',
        radius: ['40%', '70%'],
        center: ['70%', '50%'],
        data: withPercentages,
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 20,
          }
        },
        labelLine: {
          show: false
        },
      }
    ]
  };

  const onChartClick = (params: any) => {
    const {name} = params;

    const filterValues = values.redirect[name];

    if(filterValues){
      filterAlarm([filterValues.filter]);
      filterDeviceType([filterValues.type]);
      if(filterValues.userTag){
        filterUserTags([filterValues.userTag]);
      }
      location.hash = "safemates";
    }
  };

  const onEvents = {
    click: onChartClick,
    legendselectchanged: onChartClick
  };

  return (
    <Container>
      <Header>{title}</Header>
      <EChartsReact option={options} 
      onEvents={onEvents} />
    </Container>
  )
}))

export default Donut;